import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

const FN_URL = 'https://btdlohjmjogzkefjmvpn.supabase.co/functions/v1/registar-sessao-externa';
const C = { purple:'#691FB1', purpleLight:'#EDE7F6', border:'#E4DEFA', text:'#1A1A2E', textLight:'#8888AA', white:'#fff', green:'#27AE60', bg:'#F7F5FC' };

async function chamar(body) {
  const res = await fetch(FN_URL, { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify(body) });
  return res.json();
}

export default function RegistarSessaoExterna() {
  const [codigo, setCodigo] = useState('');
  const [autenticado, setAutenticado] = useState(false);
  const [nome, setNome] = useState('');
  const [clientes, setClientes] = useState([]);
  const [profissionais, setProfissionais] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [erro, setErro] = useState('');
  const [aLogar, setALogar] = useState(false);

  // Form da sessao
  const [data, setData] = useState('');
  const [cliente, setCliente] = useState('');
  const [atividade, setAtividade] = useState('');
  const [profissional, setProfissional] = useState('');
  const [valorPago, setValorPago] = useState('');
  const [valorPagar, setValorPagar] = useState('');
  const [notas, setNotas] = useState('');
  const [aGravar, setAGravar] = useState(false);
  const [msg, setMsg] = useState('');
  const [minhas, setMinhas] = useState([]);
  // mapas de agendamento
  const [aba, setAba] = useState('sessoes');      // 'sessoes' | 'mapas'
  const [agendas, setAgendas] = useState([]);
  const [agendaAberta, setAgendaAberta] = useState(null);
  const [slots, setSlots] = useState([]);
  const [aCarregarMapa, setACarregarMapa] = useState(false);
  const [modulos, setModulos] = useState(['sessoes','mapas']);

  const entrar = async () => {
    if (!codigo.trim()) { setErro('Introduz o teu código.'); return; }
    setALogar(true); setErro('');
    const r = await chamar({ acao:'login', codigo: codigo.trim() });
    setALogar(false);
    if (!r.ok) { setErro(r.error || 'Código inválido.'); return; }
    setNome(r.nome); setClientes(r.clientes||[]); setProfissionais(r.profissionais||[]);
    // a lista de atividades vem com o login (a tabela só abre a quem tem sessão no HUB)
    setAtividades(Array.isArray(r.atividades) ? r.atividades : []);
    setAutenticado(true);
    if(Array.isArray(r.modulos)&&r.modulos.length){ setModulos(r.modulos); setAba(r.modulos.includes('sessoes')?'sessoes':'mapas'); }
    carregarMinhas(codigo.trim());
    carregarAgendas(codigo.trim());
  };

  const carregarMinhas = async (cod) => {
    const r = await chamar({ acao:'listar', codigo: cod });
    if (r.ok) setMinhas(r.sessoes||[]);
  };

  const carregarAgendas = async (cod) => {
    const r = await chamar({ acao:'agendas', codigo: cod });
    if (r.ok) setAgendas(r.agendas||[]);
  };
  const abrirMapa = async (ag) => {
    if (agendaAberta?.id === ag.id) { setAgendaAberta(null); setSlots([]); return; }
    setACarregarMapa(true);
    const r = await chamar({ acao:'slots', codigo: codigo.trim(), agenda_id: ag.id });
    setACarregarMapa(false);
    if (r.ok) { setAgendaAberta(ag); setSlots(r.slots||[]); }
  };
  const marcar = async (s, estado) => {
    setSlots(prev=>prev.map(x=>x.id===s.id?{...x, estado}:x));
    await chamar({ acao:'presenca', codigo: codigo.trim(), slot_id: s.id, estado });
  };
  const modalidadeSlot = async (s, modalidade) => {
    setSlots(prev=>prev.map(x=>x.id===s.id?{...x, modalidade}:x));
    await chamar({ acao:'presenca', codigo: codigo.trim(), slot_id: s.id, estado: s.estado==='Livre'?'Livre':s.estado, modalidade });
  };
  const nomeSlot = async (s, participante) => {
    setSlots(prev=>prev.map(x=>x.id===s.id?{...x, participante}:x));
    await chamar({ acao:'presenca', codigo: codigo.trim(), slot_id: s.id,
                   estado: participante ? (s.estado==='Livre'?'Agendado':s.estado) : 'Livre', participante });
  };
  const notaSlot = async (s, nota) => {
    setSlots(prev=>prev.map(x=>x.id===s.id?{...x, nota}:x));
    await chamar({ acao:'presenca', codigo: codigo.trim(), slot_id: s.id, estado: s.estado==='Livre'?'Agendado':s.estado, nota });
  };

  const gravar = async () => {
    if (!data || !cliente || !profissional) { setMsg('Preenche data, cliente e profissional.'); return; }
    setAGravar(true); setMsg('');
    const r = await chamar({ acao:'criar', codigo: codigo.trim(), data, cliente, atividade, profissional, valor_pago: valorPago||null, valor_pagar: valorPagar||null, notas: notas||null });
    setAGravar(false);
    if (!r.ok) { setMsg(r.error || 'Erro ao gravar.'); return; }
    setMsg('Sessão registada!');
    setData(''); setCliente(''); setAtividade(''); setProfissional(''); setValorPago(''); setValorPagar(''); setNotas('');
    carregarMinhas(codigo.trim());
    setTimeout(()=>setMsg(''), 3000);
  };

  const inp = { width:'100%', padding:'11px 13px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box' };
  const lbl = { fontSize:12, fontWeight:600, color:C.textLight, display:'block', marginBottom:5 };
  const fmtD = (d) => { try { return new Date(d+'T00:00:00').toLocaleDateString('pt-PT'); } catch { return d; } };

  // ECRA 1: pedir codigo
  if (!autenticado) {
    return (
      <div style={{ minHeight:'100vh', background:C.bg, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans',sans-serif", padding:20 }}>
        <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:wght@700&display=swap" rel="stylesheet"/>
        <div style={{ background:C.white, borderRadius:16, padding:40, width:400, boxShadow:'0 8px 40px rgba(105,31,177,0.12)' }}>
          <div style={{ textAlign:'center', marginBottom:8, fontFamily:"'Fraunces',serif", color:C.purple, fontSize:26, fontWeight:700 }}>Workwell</div>
          <h1 style={{ margin:'0 0 8px', fontFamily:"'Fraunces',serif", color:C.text, fontSize:19, textAlign:'center' }}>Registo de Sessões</h1>
          <p style={{ margin:'0 0 24px', color:C.textLight, fontSize:13, textAlign:'center', lineHeight:1.5 }}>Introduz o teu código de acesso para registares as tuas sessões.</p>
          <label style={lbl}>Código de acesso</label>
          <input value={codigo} onChange={e=>setCodigo(e.target.value)} onKeyDown={e=>{if(e.key==='Enter')entrar();}} placeholder="WW-EXT-2026-XX"
            style={{ ...inp, fontFamily:'monospace', fontWeight:700, color:C.purple, textAlign:'center', marginBottom:16 }}/>
          {erro && <div style={{ background:'#FDEDEC', borderRadius:8, padding:'10px 12px', fontSize:13, color:'#C0392B', marginBottom:16 }}>{erro}</div>}
          <button onClick={entrar} disabled={aLogar} style={{ width:'100%', padding:'12px', background:C.purple, border:'none', borderRadius:8, color:'white', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>{aLogar?'A entrar...':'Entrar'}</button>
        </div>
      </div>
    );
  }

  // ECRA 2: formulario + lista das minhas sessoes
  return (
    <div style={{ minHeight:'100vh', background:C.bg, fontFamily:"'DM Sans',sans-serif", padding:'24px 16px' }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:wght@700&display=swap" rel="stylesheet"/>
      <div style={{ maxWidth:560, margin:'0 auto' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
          <div>
            <div style={{ fontFamily:"'Fraunces',serif", color:C.purple, fontSize:22, fontWeight:700 }}>Olá, {nome.split(' ')[0]}</div>
            <div style={{ fontSize:12, color:C.textLight }}>Regista aqui as tuas sessões</div>
          </div>
          <button onClick={()=>{ setAutenticado(false); setCodigo(''); }} style={{ background:'transparent', border:`1px solid ${C.border}`, borderRadius:8, color:C.textLight, padding:'7px 14px', fontSize:12, cursor:'pointer' }}>Sair</button>
        </div>

        <div style={{ display:'flex', gap:8, marginBottom:16 }}>
          {[['sessoes','📝 Registar sessões'],['mapas',`🗓️ Mapas de agendamento${agendas.length?` (${agendas.length})`:''}`]].filter(([k])=>modulos.includes(k)).map(([k,l])=>(
            <button key={k} onClick={()=>setAba(k)}
              style={{ flex:1, padding:'10px 8px', borderRadius:10, border:`1px solid ${aba===k?C.purple:C.border}`, background:aba===k?C.purpleLight:C.white,
                       color:aba===k?C.purple:C.textLight, fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>{l}</button>
          ))}
        </div>

        {aba==='mapas'&&(
          <div style={{ background:C.white, borderRadius:14, padding:24, boxShadow:'0 4px 20px rgba(105,31,177,0.06)', marginBottom:20 }}>
            <h2 style={{ margin:'0 0 14px', fontFamily:"'Fraunces',serif", color:C.purple, fontSize:17 }}>Mapas de agendamento</h2>
            {agendas.length===0&&<div style={{ fontSize:13, color:C.textLight, fontStyle:'italic' }}>Sem dias agendados para os teus clientes.</div>}
            {agendas.map(ag=>(
              <div key={ag.id} style={{ border:`1px solid ${C.border}`, borderRadius:10, marginBottom:10, overflow:'hidden' }}>
                <div onClick={()=>abrirMapa(ag)} style={{ padding:'12px 14px', cursor:'pointer', background: agendaAberta?.id===ag.id?C.purpleLight:'#FBFAFF' }}>
                  <div style={{ fontSize:14, fontWeight:700, color:C.purple }}>{fmtD(ag.data)} · {ag.servico}</div>
                  <div style={{ fontSize:12, color:C.textLight, marginTop:2 }}>
                    {ag.projeto}{ag.local?` · ${ag.local}`:''} · {String(ag.hora_inicio).slice(0,5)}–{String(ag.hora_fim).slice(0,5)}
                  </div>
                </div>
                {agendaAberta?.id===ag.id&&(
                  <div style={{ padding:'10px 12px 14px' }}>
                    {aCarregarMapa&&<div style={{ fontSize:12, color:C.textLight }}>A carregar…</div>}
                    {slots.filter(s=>s.estado!=='Bloqueado').map(s=>(
                      <div key={s.id} style={{ borderBottom:'1px solid #F4F1FB', padding:'8px 0' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
                          <span style={{ fontSize:13, fontWeight:700, minWidth:92 }}>{String(s.hora_inicio).slice(0,5)}–{String(s.hora_fim).slice(0,5)}</span>
                          <input defaultValue={s.participante||''} onBlur={e=>{ if(e.target.value!==(s.participante||'')) nomeSlot(s, e.target.value); }}
                            placeholder="nome (opcional)"
                            style={{ flex:1, minWidth:130, padding:'7px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:13, fontFamily:"'DM Sans',sans-serif" }}/>
                          <select value={s.modalidade||'Presencial'} onChange={e=>modalidadeSlot(s, e.target.value)}
                            style={{ padding:'6px 8px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif", color:(s.modalidade==='Online')?'#1A6FA0':C.textLight }}>
                            {['Presencial','Online'].map(m=><option key={m}>{m}</option>)}
                          </select>
                          {s.modalidade==='Online'&&s.link_sessao&&(
                            <a href={s.link_sessao} target="_blank" rel="noreferrer"
                              style={{ background:'#E5F1FB', color:'#1A6FA0', borderRadius:8, padding:'6px 12px', fontSize:12, fontWeight:700, textDecoration:'none', whiteSpace:'nowrap' }}>💻 Entrar na sessão</a>
                          )}
                          {(
                            <div style={{ display:'flex', gap:6 }}>
                              <button onClick={()=>marcar(s,'Compareceu')}
                                style={{ padding:'6px 12px', borderRadius:8, border:'none', cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif",
                                         background:s.estado==='Compareceu'?C.green:'#EAFAF1', color:s.estado==='Compareceu'?'#fff':C.green }}>✓ Veio</button>
                              <button onClick={()=>marcar(s,'Chegou atrasado')}
                                style={{ padding:'6px 10px', borderRadius:8, border:'none', cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif",
                                         background:s.estado==='Chegou atrasado'?'#E67E22':'#FEF5E7', color:s.estado==='Chegou atrasado'?'#fff':'#E67E22' }}>⏰ Atrasado</button>
                              <button onClick={()=>marcar(s,'Não compareceu')}
                                style={{ padding:'6px 12px', borderRadius:8, border:'none', cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif",
                                         background:s.estado==='Não compareceu'?'#C0392B':'#FDECEA', color:s.estado==='Não compareceu'?'#fff':'#C0392B' }}>✗ Faltou</button>
                            </div>
                          )}
                        </div>
                        <input defaultValue={s.nota||''} onBlur={e=>{ if(e.target.value!==(s.nota||'')) notaSlot(s, e.target.value); }}
                          placeholder="nota (opcional)"
                          style={{ width:'100%', marginTop:6, padding:'6px 9px', border:`1px solid ${C.border}`, borderRadius:6, fontSize:12, fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }}/>
                      </div>
                    ))}
                    {!aCarregarMapa&&slots.filter(s=>s.estado!=='Bloqueado').length===0&&
                      <div style={{ fontSize:12, color:C.textLight }}>Sem marcações neste dia.</div>}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {aba==='sessoes'&&<>
        <div style={{ background:C.white, borderRadius:14, padding:24, boxShadow:'0 4px 20px rgba(105,31,177,0.06)', marginBottom:20 }}>
          <h2 style={{ margin:'0 0 18px', fontFamily:"'Fraunces',serif", color:C.purple, fontSize:17 }}>Nova sessão</h2>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
            <div><label style={lbl}>Data</label><input type="date" value={data} onChange={e=>setData(e.target.value)} style={inp}/></div>
            <div><label style={lbl}>Cliente</label><select value={cliente} onChange={e=>setCliente(e.target.value)} style={inp}><option value="">Escolher...</option>{clientes.map(c=><option key={c} value={c}>{c}</option>)}</select></div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
            <div><label style={lbl}>Atividade</label><select value={atividade} onChange={e=>setAtividade(e.target.value)} style={inp}><option value="">Escolher...</option>{atividades.map(a=><option key={a} value={a}>{a}</option>)}</select></div>
            <div><label style={lbl}>Profissional</label><select value={profissional} onChange={e=>setProfissional(e.target.value)} style={inp}><option value="">Escolher...</option>{profissionais.map(p=><option key={p} value={p}>{p}</option>)}</select></div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:18 }}>
            <div><label style={lbl}>Valor pago pelo colaborador (€)</label><input type="number" value={valorPago} onChange={e=>setValorPago(e.target.value)} placeholder="0" style={inp}/></div>
            <div><label style={lbl}>Valor a pagar ao profissional (€)</label><input type="number" value={valorPagar} onChange={e=>setValorPagar(e.target.value)} placeholder="0" style={inp}/></div>
          </div>
          <div style={{ marginBottom:18 }}><label style={lbl}>Notas (opcional)</label><textarea value={notas} onChange={e=>setNotas(e.target.value)} placeholder="Observações sobre a sessão..." rows={3} style={{ ...inp, resize:'vertical', fontFamily:"'DM Sans',sans-serif" }}/></div>
          {msg && <div style={{ background: msg.includes('registada')?'#EAFAF1':'#FDEDEC', borderRadius:8, padding:'10px 12px', fontSize:13, color: msg.includes('registada')?C.green:'#C0392B', marginBottom:14 }}>{msg}</div>}
          <button onClick={gravar} disabled={aGravar} style={{ width:'100%', padding:'12px', background:C.purple, border:'none', borderRadius:8, color:'white', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>{aGravar?'A gravar...':'Registar sessão'}</button>
        </div>

        <div style={{ background:C.white, borderRadius:14, padding:24, boxShadow:'0 4px 20px rgba(105,31,177,0.06)' }}>
          <h2 style={{ margin:'0 0 14px', fontFamily:"'Fraunces',serif", color:C.purple, fontSize:17 }}>Sessões que registei ({minhas.length})</h2>
          {minhas.length===0 ? <div style={{ fontSize:13, color:C.textLight, fontStyle:'italic' }}>Ainda não registaste sessões.</div> :
           <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
             {minhas.map(s=>(
               <div key={s.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 12px', border:`1px solid ${C.border}`, borderRadius:8 }}>
                 <div>
                   <div style={{ fontSize:13, fontWeight:600, color:C.text }}>{fmtD(s.date)} · {s.client}</div>
                   <div style={{ fontSize:11, color:C.textLight, marginTop:2 }}>{s.professional}{s.activity?` · ${s.activity}`:''}</div>
                 </div>
                 <div style={{ fontSize:13, fontWeight:700, color:C.purple }}>{s.value_to_pay!=null?`${s.value_to_pay}€`:'—'}</div>
               </div>
             ))}
           </div>}
        </div>
        </>}
      </div>
    </div>
  );
}
